export default {
  default: {
    buttons: {
      add: 'Add Recipient Role',
    },
  },
}
